<div class="d-flex flex-column main min-vh-100">
  <div class="shadow-sm" style="z-index: 9999">
    <app-header *ngIf="isLoggedIn"></app-header>
  </div>
  <!-- <div class="placeholder"></div> -->

  <main class="flex-grow-1 h-0 overflow-y-auto">
    <app-campaign-banner *ngIf="isHomePage"></app-campaign-banner>
    <div class="container-fluid px-4">
      <router-outlet></router-outlet>
    </div>
  </main>

  <app-footer *ngIf="isLoggedIn"></app-footer>

  <notifier-container></notifier-container>
  <app-call-support-action-button></app-call-support-action-button>
</div>
